<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center">
                <img class="w-10/12" src="images/logo/logo-grupo-platino.png" />
            </div>

            <!-- Components -->
            <div class="ml-auto flex items-center">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex w-full flex-col items-center p-4">
            <div class="relative h-24 w-24">
                @if (user.profilePicture) {
                    <div class="group relative inline-block">
                        <img
                            class="h-24 w-24 transform rounded-full"
                            [src]="user.profilePicture"
                            alt="User avatar"
                        />
                        <button
                            (click)="fileInput.click()"
                            mat-icon-button
                            class="absolute -right-1 -top-1 rounded-full bg-blue-900 opacity-0 transition-opacity group-hover:opacity-100"
                        >
                            <mat-icon
                                class="text-white"
                                [svgIcon]="'heroicons_outline:pencil'"
                            ></mat-icon>
                        </button>

                        <input
                            #fileInput
                            type="file"
                            (change)="onFileSelected($event)"
                            hidden
                        />

                        <button
                            (click)="removeProfilePicture()"
                            class="absolute bottom-0 left-0 flex h-8 w-8 items-center justify-center rounded-full bg-red-700 p-2 opacity-0 transition-opacity hover:bg-red-600 group-hover:opacity-100"
                        >
                            <mat-icon
                                class="text-white"
                                [svgIcon]="'heroicons_outline:x-mark'"
                            ></mat-icon>
                        </button>
                    </div>
                }
                @if (!user.profilePicture) {
                    <div class="group">
                        <mat-icon
                            class="h-full w-full transform rounded-full"
                            [svgIcon]="'heroicons_solid:user-circle'"
                        >
                        </mat-icon>

                        <button
                            (click)="fileInput.click()"
                            mat-icon-button
                            class="absolute right-0 top-0 rounded-full bg-blue-900 p-2 opacity-0 transition-opacity group-hover:opacity-100"
                        >
                            <mat-icon
                                class="text-gray-300"
                                [svgIcon]="'heroicons_outline:pencil'"
                            ></mat-icon>
                        </button>

                        <input
                            #fileInput
                            type="file"
                            (change)="onFileSelected($event)"
                            hidden
                        />
                    </div>
                }
            </div>
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.fullName }}
                </div>
                <div
                    class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
                >
                    {{ user.email }}
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12"
        >
            <img class="max-w-36" src="" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            @if (canViewCRMConnect || canViewCareerPortal || canViewCMS) {
                <button
                    class="flex items-center rounded-md border-2 border-gray-700 p-2 transition-colors duration-400 hover:border-gray-500 hover:bg-gray-300 hover:dark:bg-slate-800"
                    [matMenuTriggerFor]="menu"
                >
                    <mat-icon svgIcon="feather:download"></mat-icon>
                    <span class="ml-2">Descargar Manual</span>
                </button>
                <mat-menu #menu="matMenu">
                    @if (canViewCRMConnect) {
                        <a
                            [href]="manualCRMConnect"
                            mat-menu-item
                            target="_blank"
                        >
                            <mat-icon svgIcon="feather:book"></mat-icon>
                            <span>Manual de CRM Connect</span>
                        </a>
                    }
                    @if (canViewCareerPortal) {
                        <a
                            [href]="manualCareerPortal"
                            mat-menu-item
                            target="_blank"
                        >
                            <mat-icon svgIcon="feather:book"></mat-icon>
                            <span>Manual de Career Portal</span>
                        </a>
                    }
                    @if (canViewCMS) {
                        <a [href]="manualCMS" mat-menu-item target="_blank">
                            <mat-icon svgIcon="feather:book"></mat-icon>
                            <span> Manual de CMS</span>
                        </a>
                    }
                </mat-menu>
            }

            @if (scheme == 'light') {
                <button mat-icon-button (click)="setScheme('dark')">
                    <mat-icon [svgIcon]="'heroicons_outline:moon'"></mat-icon>
                </button>
            } @else if (scheme == 'dark') {
                <button mat-icon-button (click)="setScheme('light')">
                    <mat-icon [svgIcon]="'heroicons_outline:sun'"></mat-icon>
                </button>
            }

            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>
